module.exports = __webpack_public_path__ + "static/media/img-banner-Lojista-ebit-02.7a382624.7a382624.png";